import { render, staticRenderFns } from "./PaginatedResult.vue?vue&type=template&id=60aec92f"
import script from "./PaginatedResult.vue?vue&type=script&lang=js"
export * from "./PaginatedResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports